import {useEffect, useRef} from "react";
import { loadModules } from "esri-loader";
import "../../style/layerStyle.css"


const StreetViewComponent = (props) =>  {
    const viewDivRef = useRef(null);
    const overviewDivRef = useRef(null);
    const extentDivRef = useRef(null);
    useEffect(() => {

        changeView()

        /*loadModules([
            'esri/Map',
            'esri/views/SceneView',
            'esri/views/MapView',
            'esri/Graphic',
            'esri/core/reactiveUtils',
            'esri/core/promiseUtils',
        ]).then(
            ([
                 Map,
                 SceneView,
                 MapView,
                 Graphic,
                 reactiveUtils,
                 promiseUtils,
             ]) => {
                const mainMap = new Map({
                    basemap: 'hybrid',
                    ground: 'world-elevation',
                });
                const overviewMap = new Map({
                    basemap: 'topo-vector',
                });
                const mainView = new SceneView({
                    container: viewDivRef.current,
                    map: props.sceneView.map,
                    camera: {
                        position: {
                            spatialReference: {
                                latestWkid: 3857,
                                wkid: 3857,
                            },
                            x: 925151,
                            y: 5956309,
                            z: 3871,
                        },
                        heading: 203,
                        tilt: 72,
                    },
                });
                const mapView = new MapView({
                    container: overviewDivRef.current,
                    map: overviewMap,
                    constraints: {
                        rotationEnabled: false,
                    },
                });
                mapView.ui.components = [];
                mapView.when(() => {
                    mainView.when(() => {
                        setup();
                    });
                });
                const extentDebouncer = promiseUtils.debounce(async () => {
                    if (mainView.stationary) {
                        await mapView.goTo({
                            center: mainView.center,
                            scale:
                                mainView.scale *
                                2 *
                                Math.max(
                                    mainView.width / mapView.width,
                                    mainView.height / mapView.height
                                ),
                        });
                    }
                });

                function setup() {
                    const extent3Dgraphic = new Graphic({
                        geometry: null,
                        symbol: {
                            type: 'simple-fill',
                            color: [0, 0, 0, 0.5],
                            outline: null,
                        },
                    });
                    mapView.graphics.add(extent3Dgraphic);
                    reactiveUtils.watch(
                        () => mainView.extent,
                        (extent) => {
                            extentDebouncer().then(() => {
                                extent3Dgraphic.geometry = extent;
                            });
                        },
                        {
                            initial: true,
                        }
                    );
                }
            }
        );
            */
    }, [props.streetViewKey, props.mapView]);


    const changeView = () => {

        props.sceneDiv.current.classList.add("mapView")

        props.overviewDiv.current.classList.add("overView")

        props.mapDiv.current.classList.remove('mapView');

    }

    const changeViewBack = () => {

        props.sceneDiv.current.classList.remove('overView');

        props.overviewDiv.current.classList.remove('overView');

        props.mapDiv.current.classList.add("mapView")

    }

    return (
        <>
            {/*<div
                ref={viewDivRef}
                style={{ padding: 0, margin: 0, height: '100%', width: '100%', zIndex: -1 }}
            />*/}
            {/*<div
                ref={overviewDivRef}
                style={{
                    position: 'absolute',
                    top: '10%',
                    right: 12,
                    width: 300,
                    height: 200,
                    border: '1px solid black',
                    zIndex: 1,
                    overflow: 'hidden',
                }}
            >
                <div ref={extentDivRef} style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)', position: 'absolute', zIndex: 2 }} />
            </div>*/}
            <button hidden={true}
                ref={props.changeSceneButton}
                id="clear" onClick={changeView}>show</button>

            <button hidden={true}
                ref={props.changeViewButton}
                id="clear" onClick={changeViewBack}>hide</button>
        </>
    );
};
export default StreetViewComponent;